'use client'

import * as React from 'react'

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

interface InClassNoticeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function InClassNoticeDialog({ open, onOpenChange }: InClassNoticeDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className='srd:data-[size=default]:max-w-[560px] srd:h-fit srd:max-h-[90dvh] srd:overflow-y-auto'>
        <AlertDialogHeader className='srd:sr-only'>
          <AlertDialogTitle>Latihan Ini Butuh Pendamping</AlertDialogTitle>
          <AlertDialogDescription>
            Modul ini mengandung aktivitas kelas yang perlu dilakukan bersama orang tua atau guru. Minta pendampingmu
            untuk membantumu ya!
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className='srd:flex srd:flex-col srd:gap-y-2 srd:items-center srd:justify-center srd:text-center'>
          <img src={getStaticAssetUrl('illustration/foam.png')} alt='' draggable={false} height={108} />

          <h6 className={cn(typographyVariants({ variant: 'headline-sm' }), 'srd:text-neutral-black')}>
            Eits, perlu pendampingan!
          </h6>

          <p className={cn(typographyVariants({ variant: 'body-md' }), 'srd:text-grey-100')}>
            Latihan ini harus dinilai guru atau orang tua. Yuk, ajak mereka menemani kamu belajar.
          </p>
        </div>

        <AlertDialogCancel render={<Button className='srd:mt-4 srd:w-fit srd:mx-auto'>Kembali</Button>} />
      </AlertDialogContent>
    </AlertDialog>
  )
}
